/**
 * Static Survey Thank-You Page
 *
 * A session-less completion page for integrations that need a fixed, permanent URL to redirect
 * respondents to when there is no survey session id to build `/survey-complete/:sessionId` from.
 *
 * Makes no API call and always renders the success panel. An optional `?message=` query param
 * overrides the body copy for a custom integration (React escapes it, so it is safe to render).
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Check } from 'lucide-react';
import { UI_TEXT } from '../../config/ui-text';

const StaticThankYou: React.FC = () => {
  const [searchParams] = useSearchParams();
  const customMessage = searchParams.get('message')?.trim();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-2xl mx-auto px-4">
        <div className="bg-white rounded-xl shadow-sm text-center p-8">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check className="w-8 h-8 text-green-600" />
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            {UI_TEXT.HUMAN_SURVEY.COMPLETE.TITLES.THANK_YOU}
          </h1>

          <p className="text-lg text-gray-600 mb-6">
            {customMessage || UI_TEXT.HUMAN_SURVEY.COMPLETE.MESSAGES.SUCCESS}
          </p>

          <div className="space-y-4">
            <p className="text-sm text-gray-500">
              {UI_TEXT.HUMAN_SURVEY.COMPLETE.MESSAGES.CLOSE_TAB}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaticThankYou;
